import { useEffect, useRef, useState } from "react";

const ClientSuggesstionPopup = (props) => {
  const popupref = useRef(null);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const normalizeText = (val) =>
      (val || "").toString().toLowerCase().replace(/\s+/g, " ").trim();

    const normalizePhone = (val) => (val || "").toString().replace(/\D/g, "");

    const filtered = (props.data || []).filter((item) => {
      let value = "";

      if (props.fieldtype === "name") {
        value = normalizeText(item.name);
      } else if (props.fieldtype === "phone") {
        value = normalizePhone(item.phone);
      } else {
        value = normalizeText(item.email);
      }

      // 🚨 Empty values skip kr do
      if (!value) return false;

      const searchValue =
        props.fieldtype === "phone"
          ? normalizePhone(search)
          : normalizeText(search);

      return value.includes(searchValue);
    });

    setFilteredData(filtered);
  }, [search, props.data, props.fieldtype]);

  return (
    props.visible && (
      <div
        ref={popupref}
        className="w-[300px] bg-white border border-gray-300 rounded-md p-[10px] absolute z-10 top-[50px] right-0 lg:left-[0px] shadow-lg"
        style={props.style}
      >
        {/* SEARCH BAR */}
        <input
          type="text"
          value={search}
          placeholder={`Search ${props.fieldtype}`}
          onChange={(e) => {
            setSearch(e.target.value);

            // 🔥 parent function call
            props.onSearch?.(e.target.value);
          }}
          className="px-3 text-sm w-full py-2 rounded-lg border-2 border-gray-300 mb-2 outline-none focus:border-[#1E293B]"
        />

        {/* Add-new: use exactly what was typed, even if it's not an existing
            contact. Lets you enter a brand-new professional inline. */}
        {props.onAddNew && search.trim() && (
          <div
            onClick={() => props.onAddNew(search.trim())}
            className="flex items-center w-full py-2 mb-1 cursor-pointer hover:bg-emerald-600 hover:text-white text-sm rounded-xl px-[10px] border border-dashed border-emerald-300"
          >
            <p className="font-medium PoppinsRegular text-sm">
              ＋ Use “{search.trim()}”
            </p>
          </div>
        )}

        <div className="w-full overflow-y-auto max-h-[180px]">
          {filteredData.length === 0 ? (
            <p className="text-sm text-gray-400 px-2 py-2 text-center">
              {props.onAddNew && search.trim()
                ? "No match — use the option above to add it"
                : "No suggestions found"}
            </p>
          ) : (
            [...filteredData]
              .sort((a, b) => {
                const key =
                  props.fieldtype === "name"
                    ? "name"
                    : props.fieldtype === "phone"
                      ? "phone"
                      : "email";
                return (a[key] || "").toString().toLowerCase().localeCompare(
                  (b[key] || "").toString().toLowerCase()
                );
              })
              .map((item, index) => {
              const value =
                props.fieldtype === "name"
                  ? item.name
                  : props.fieldtype === "phone"
                    ? item.phone
                    : item.email;

              return (
                <div
                  key={index}
                  onClick={() => props.onClickcorrect(item)}
                  className="flex items-center w-full py-2 cursor-pointer hover:bg-[#1E293B] hover:text-white text-sm hover:rounded-xl hover:px-[10px]"
                >
                  <p className="ml-[10px] font-medium PoppinsRegular text-sm">
                    {value}
                  </p>
                </div>
              );
            })
          )}
        </div>
      </div>
    )
  );
};

export default ClientSuggesstionPopup;
